module.exports = __webpack_public_path__ + "assets/img/es-d08d51cd.png";